




import { Vue, Component } from 'vue-property-decorator'

export default Vue.extend({
    name: "Redirect",
    data() {
        return {
            access_token: null,
            status: "Siirretään tapahtumaan..."
        }
    },
    created(): void {
        const resource = localStorage.getItem("resource");
        const query = this.$route.query

        this.$store.dispatch("API_CALL", { method: "get", url: `/auth/ftn/token`, params: { ...query, event: resource } }).then((res) => {
            const { user, access_token } = res.data

            localStorage.access_token = access_token;
            this.$store.commit("setUserInfo", res.data);
            this.$router.push("/" + resource);
        }).catch((err) => {
            localStorage.removeItem("access_token");
            this.status = err.response.data.message;

            this.$router.push("/" + resource);
        })
    }
})
